module.exports = __webpack_public_path__ + "img/M857.fdbd05ec.jpg";